import { Box } from '@branch-messenger/willow-ui'
import { FC, ReactNode } from 'react'

export type AccountDetailLeadingIconProps = {
  children: ReactNode
}

export const AccountDetailLeadingIcon: FC<AccountDetailLeadingIconProps> = ({
  children,
}) => {
  return (
    <Box $display="flex" $align="center">
      {children}
    </Box>
  )
}
